import Table from '@components/table'
const Appointments = () => {
  const columns = [
    {
      title: 'Id',
      key: 'id',
    },
    {
      title: 'Patient',
      key: 'patient',
    },
    {
      title: 'Treatments',
      key: 'treatments',
    },
    {
      title: 'Appointment Type',
      key: 'appointmentType',
    },
    {
      title: 'Date',
      key: 'date',
    },
    {
      title: 'Status',
      key: 'status',
    },
  ]
  return <Table columns={columns} />
}

export default Appointments
